<template>
  <div style="height: inherit">
    <conciliacao-pagamento-itens-header />
    <conciliacao-pagamento-itens-status-bar class="mb-2" />
    <v-progress-linear v-if="loading" indeterminate />
    <div v-else style="overflow-y: auto; height: calc(100% - 96px - 8px)">
      <template v-if="!showFaturamentoItens">
        <v-container class="text-center text-uppercase">
          Selecione pelo menos uma guia de faturamento para conciliar os itens
        </v-container>
      </template>
      <template v-else-if="countItens === 0">
        <v-container class="text-center text-wrap">
          <div v-if="selectedPagamentoItensFilterOption === 'todos'">Nenhum item encontrado</div>
          <div v-else-if="selectedPagamentoItensFilterOption === 'conciliados'">Nenhum item conciliado</div>
          <div v-else-if="selectedPagamentoItensFilterOption === 'nao-conciliados'">Todos os itens estão conciliados</div>
        </v-container>
      </template>
      <template v-else-if="countItens > 0">
        <conciliacao-pagamento-item-card
          v-for="item in itens"
          :key="item.id"
          :pagamento-item="item"
          :isUsuarioTradimus="isUsuarioTradimus"
          @click:card="handleCardClick"
          class="mb-2"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ConciliacaoPagamentoItemCard from './ConciliacaoPagamentoItemCard.vue'
import ConciliacaoPagamentoItensHeader from './ConciliacaoPagamentoItensHeader.vue'
import ConciliacaoPagamentoItensStatusBar from './ConciliacaoPagamentoItensStatusBar.vue'
import { sessionStorageClient } from '../../../libs'

export default {
  components: {
    ConciliacaoPagamentoItemCard,
    ConciliacaoPagamentoItensHeader,
    ConciliacaoPagamentoItensStatusBar
  },
  data () {
    return {
      clickedItem: undefined
    }
  },
  computed: {
    ...mapState(
      'conciliacao',
      ['pagamentoGuia', 'pagamentoItens', 'selectedPagamentoItensFilterOption', 'showFaturamentoItens']
    ),
    itens () {
      return this.pagamentoItens.result?.data
    },
    loading () {
      return this.pagamentoItens.loading
    },
    countItens () {
      return this.itens?.length
    },
    isUsuarioTradimus () {
      const usuarioTradimus = sessionStorageClient.getItem('userData')?.['UsuarioTradimus']
      return usuarioTradimus
    }
  },
  methods: {
    handleCardClick (pagamentoItem, currentChecked) {
      if (currentChecked) {
        this.$store.dispatch('conciliacao/deselectPagamentoItem', pagamentoItem)
      } else {
        this.$store.dispatch('conciliacao/selectPagamentoItem', pagamentoItem)
      }
    }
  }
}
</script>
